import React, { useState, useMemo } from "react";
import Stack from "react-bootstrap/Stack";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCirclePlus,
  faArrowRotateRight,
  faFileContract,
} from "@fortawesome/free-solid-svg-icons";
// components
import DataTable from "../../dynamic-components/DataTable";
import SideTable from "../../dynamic-components/SideTable";
import SearchBar from "../../dynamic-components/SearchBar";
import CreateShippingModal from "../../utils/modals/shipping-modal/CreateShippingModal";
import UpdateShippingModal from "../../utils/modals/shipping-modal/UpdateShippingModal";
import AddCostModal from "../../utils/modals/shipping-modal/add-shipping-cost/AddCostModal";
import EditCostModal from "../../utils/modals/shipping-modal/edit-shipping-cost/EditCostModal";
import { deleteShippingSetData } from "../../../context/api/shipping/delete-shipping/deleteShippingSetData";
import { deleteCostSetData } from "../../../context/api/shipping/delete-cost/deleteCostSetData";
import { expanded } from "../../dynamic-components/expanded";
import ConfirmModal from "../../dynamic-components/ConfirmModal";
import Message from "../../utils/modals/Message";

// tool importing
import { useCookies } from "react-cookie";

const ShipmentTable = ({ lang,
  pageClass,
  tableData,
  loader,
  setRefreshData,
  btnLoader }) => {

  const [cookies] = useCookies();
  const data = require(`../../../translate/${lang === "AR" ? "arabic" : "english"
    }/data.json`);

  const initialAddModal = {
    isShow: false,
    action: "",
    rowData: {},
  };
  const initialMessageRes = {
    success: Boolean,
    message: String,
    isShow: false,
  };
  const initialConfirmModal = {
    isShow: false,
    rowData: {},
  };
  const initialSuccessMessage = {
    success: false,
    type: "",
    data: {},
  };

  const initialAddCostModal = {
    isShow: false,
    rowData: {},
  };
  const dataTranslatePopups = data;
  const dataTranslate = data.pages.shipment_p;
  const action = {
    title: dataTranslatePopups.popups.add_shipping.delete_modal.title,
    submit: dataTranslatePopups.popups.add_shipping.delete_modal.submit,
  };
  const costAction = {
    title: dataTranslatePopups.popups.add_shipping_cost.delete_modal.title,
    submit: dataTranslatePopups.popups.add_shipping_cost.delete_modal.submit,
  }
  const searchByData = dataTranslate.table.table_head.search_by;

  const [showAddModal, setShowAddModal] = useState(initialAddModal);
  const [confirmModal, setConfirmModal] = useState(initialConfirmModal);
  const [subConfirmModal, setSubConfirmModal] = useState(initialConfirmModal);
  const [confirmBtnLoader, setConfirmBtnLoader] = useState(false);
  const [successMessage, setSuccessMessage] = useState(initialSuccessMessage);
  const [messageResponse, setMessageResponse] = useState(initialMessageRes);
  const [showAddCostModal, setShowAddCostModal] = useState(initialAddCostModal);
  const [showEditCostModal, setShowEditCostModal] = useState(initialAddCostModal);

  const [search, setSearch] = useState({
    type: "filterContainerNumber",
    value: "",
  });

  const handleSearch = (e) => {
    const value = e.target.value || undefined;
    setSearch((prev) => ({ ...prev, value: value }));
  };
  const searchOptions = [
    { key: "filterContainerNumber", value: searchByData.containerNumber },
    { key: "filterId", value: searchByData.id },
  ];
  const sideTableHeaders = tableData
    ? Object.keys(tableData[0].recordDetails)
    : "";
  const deleteShipping = async (id) => {
    const shipping_id = id;
    setConfirmBtnLoader(() => true);
    await deleteShippingSetData(
      lang,
      setMessageResponse,
      cookies,
      shipping_id,
      setSuccessMessage
    );
    setConfirmBtnLoader(() => false);
  }
  const deleteCost = async (id) => {
    const cost_id = id;
    setConfirmBtnLoader(() => true);
    await deleteCostSetData(
      lang,
      setMessageResponse,
      cookies,
      cost_id,
      setSuccessMessage
    );
    setConfirmBtnLoader(() => false);
  }
  const columns = useMemo(
    () => [
      {
        // Header: searchByData.recordNumber,
        // Header: "filterId",
        accessor: "filterId",
      },
      {
        // Header: searchByData.recordNumber,
        // Header: "filterId",
        accessor: "filterContainerNumber",
      },
      {
        Header: dataTranslate.table.table_body.recordDetails.title,
        accessor: "recordDetails",
        Cell: ({ cell }) => {
          return (
            <SideTable
              data={dataTranslate}
              cell={cell}
              headers={sideTableHeaders}
              side_table_name="recordDetails"
            />
          );
        },
      },
      {
        Header: dataTranslate.table.table_body.totalCost,
        accessor: "totalCost",
      },
      {
        Header: dataTranslate.table.table_body.totalPaid,
        accessor: "totalPaid",
      },
      {
        Header: dataTranslate.table.table_body.counstShipments,
        accessor: "counstShipments",
      },
      {
        Header: dataTranslate.table.table_body.creation_date,
        accessor: "creation_date",
      },
      {
        Header: dataTranslate.table.table_body.NB,
        accessor: "NB",
      },

      {
        Header: dataTranslate.table.table_body.action,
        Cell: ({ cell }) => {
          return (
            <div className="d-flex flex-column gap-3 align-content-center justify-content-center">
              <button
                className="shipment_p-table-table-body-btn"
                onClick={() =>
                  setShowAddModal((prev) => ({
                    ...prev,
                    isShow: true,
                    action: "update",
                    rowData: cell.row.original,
                  }))
                }>
                {dataTranslate.table.table_body.edit}
              </button>
              <button
                className="shipment_p-table-table-body-btn"
                onClick={() =>
                  setShowAddCostModal((prev) => ({
                    ...prev,
                    isShow: true,
                    rowData: {
                      id: cell.row.original.id
                    }
                  }))}
              >
                {dataTranslate.table.table_body.add}
              </button>
              <button
                className="shipment_p-table-table-body-btn-delete"
                onClick={() =>
                  setConfirmModal((prev) => ({
                    ...prev,
                    isShow: true,
                    rowData: cell.row.original,
                  }))}
              >
                {dataTranslate.table.table_body.delete}
              </button>
            </div>
          );
        },
      },

      expanded(),
    ],
    []
  );

  const subColumns = useMemo(
    () => [
      {
        Header: dataTranslatePopups.home_tabs.shipment_tab.table.table_body.sub_table.id,
        accessor: "id",
      },
      {
        Header: dataTranslatePopups.home_tabs.shipment_tab.table.table_body.sub_table.onName,
        accessor: "onName",
      },
      {
        Header: dataTranslatePopups.home_tabs.shipment_tab.table.table_body.sub_table.phoneNumber,
        accessor: "phoneNumber",
      },
      {
        Header: dataTranslatePopups.home_tabs.shipment_tab.table.table_body.sub_table.costAmount,
        accessor: "costAmount",
      },
      {
        Header: dataTranslatePopups.home_tabs.shipment_tab.table.table_body.sub_table.NB,
        accessor: "NB",
      },
      {
        Header: dataTranslate.table.table_body.action,
        Cell: ({ cell }) => {
          return (
            <div className="d-flex flex-row gap-3 align-content-center justify-content-center">
              <button
                className="shipment_p-table-table-body-btn"
                onClick={() =>
                  setShowEditCostModal((prev) => ({
                    ...prev,
                    isShow: true,
                    rowData: cell.row.original,
                  }))
                }
              >
                {dataTranslate.table.table_body.sub_table.edit_cost}
              </button>
              <button
                className="shipment_p-table-table-body-btn-delete"
                onClick={() =>
                  setSubConfirmModal((prev) => ({
                    ...prev,
                    isShow: true,
                    rowData: cell.row.original,
                  }))
                }
              >
                {dataTranslate.table.table_body.sub_table.delete_cost}
              </button>
            </div>
          );
        },
      },
    ],
    []
  );

  return (
    <>
      <Message
        messageResponse={messageResponse}
        close={() => setMessageResponse(initialMessageRes)}
        lang={lang}
      />

      <div className="shipment_p-table w-100 d-flex flex-column align-items-center">
        <div className="shipment_p-table-nav w-100 m-3 px-3">
          <Stack direction="horizontal" gap={3}>
            <div
              className="shipment_p-table-nav-btn"
              onClick={() =>
                setShowAddModal((prev) => ({
                  ...prev,
                  isShow: true,
                  action: "add",
                }))
              }
            >
              <span>{dataTranslate.table.table_head.add}</span>
              <FontAwesomeIcon
                icon={faCirclePlus}
                size="xl"
                style={{ color: "#f2ce00" }}
              />
            </div>
            <div
              className={
                lang === "AR"
                  ? "ms-auto shipment_p-table-nav-btn"
                  : "me-auto shipment_p-table-nav-btn"
              }
              onClick={() => {
                setRefreshData((prev) => prev + 1);
              }}
            >
              <span>{dataTranslate.table.table_head.refresh}</span>
              <FontAwesomeIcon
                icon={faArrowRotateRight}
                size="xl"
                style={{ color: "#f2ce00" }}
              />
            </div>
            <SearchBar
              lang={lang}
              search={search}
              handleSearch={handleSearch}
              options={searchOptions}
              setSearch={setSearch}
            />
          </Stack>
        </div>

        <div className="shipment_p-table-table w-100 m-3 px-3">
          <AddCostModal
            show={showAddCostModal.isShow}
            onHide={() => setShowAddCostModal(initialAddCostModal)}
            lang={lang}
            dataTranslate={data}
            data={showAddCostModal.rowData}
            setRefreshData={setRefreshData}
          />
          <EditCostModal
            show={showEditCostModal.isShow}
            onHide={() => setShowEditCostModal(initialAddCostModal)}
            lang={lang}
            dataTranslate={data}
            data={showEditCostModal.rowData}
            setRefreshData={setRefreshData}
          />

          <CreateShippingModal
            show={showAddModal.isShow}
            onHide={() => setShowAddModal(initialAddModal)}
            lang={lang}
            dataTranslate={dataTranslatePopups}
            action={showAddModal.action}
            data={showAddModal.rowData}
            setRefreshData={setRefreshData}
          />
          <UpdateShippingModal
            show={showAddModal.isShow}
            onHide={() => setShowAddModal(initialAddModal)}
            lang={lang}
            dataTranslate={dataTranslatePopups}
            action={showAddModal.action}
            data={showAddModal.rowData}
            setRefreshData={setRefreshData}
          />
          <ConfirmModal
            show={confirmModal.isShow}
            onHide={() => setConfirmModal(initialConfirmModal)}
            post={deleteShipping}
            data={confirmModal.rowData}
            lang={lang}
            dataTranslate={dataTranslatePopups}
            setRefreshData={setRefreshData}
            action={action}
            btnLoader={confirmBtnLoader}
            successMessage={successMessage}
            setSuccessMessage={setSuccessMessage}
          />
          <ConfirmModal
            show={subConfirmModal.isShow}
            onHide={() => setSubConfirmModal(initialConfirmModal)}
            post={deleteCost}
            data={subConfirmModal.rowData}
            lang={lang}
            dataTranslate={dataTranslatePopups}
            setRefreshData={setRefreshData}
            action={costAction}
            btnLoader={confirmBtnLoader}
            successMessage={successMessage}
            setSuccessMessage={setSuccessMessage}
          />
          {tableData ? (
            <DataTable
              lang={lang}
              columns={columns}
              subColumns={subColumns}
              dataTable={tableData}
              pageClass="shipment_p"
              subDataKey="costs"
              loader={loader}
              search={search}
            />
          ) : (
            ""
          )}
        </div>
      </div>
    </>

  );
};

export default ShipmentTable;
